import React from 'react';
import { Outlet } from 'react-router-dom';
import './AdminLayout.css';

const AdminLayout = () => {
  return (
    <div className="admin-layout">
      {/* No header/navigation for admin pages */}
      <Outlet />
    </div>
  );
};

export default AdminLayout; 